import { useCallback, useState } from 'react';
import { ModalTab } from '../modals';
import { useAnalytics } from '@ovotech/ui-tools';
import { EV } from '@monovo/ev-anytime';

const MODAL_STEPS = {
  WHAT_YOU_GET: 4,
  NEED_TO_KNOW: 2,
} as const;

export const useModalState = () => {
  const { dispatch: analyticsDispatch } = useAnalytics();

  const [showPaydModal, setShowPaydModal] = useState(false);
  const [showMonthlyModal, setShowMonthlyModal] = useState(false);
  const [monthlyModalTab, setMonthlyModalTab] =
    useState<ModalTab>('what-you-get');
  const [monthlyModalStep, setMonthlyModalStep] = useState(1);

  const openPaydModal = () => setShowPaydModal(true);
  const closePaydModal = () => setShowPaydModal(false);

  const openMonthlyModal = () => {
    setMonthlyModalStep(1);
    setMonthlyModalTab('what-you-get');
    setShowMonthlyModal(true);
  };

  const closeMonthlyModal = () => {
    setShowMonthlyModal(false);
    setMonthlyModalStep(1);
    setMonthlyModalTab('what-you-get');
    analyticsDispatch({
      type: 'click',
      name: EV.ELIGIBILITY.CHARGE_ANYTIME_SWITCH_SCREEN_DETAILS_CLOSE_CLICKED,
      properties: {
        detailsView: 'Pay monthly',
        pathname: '/anytime/switch',
        journeyName: EV.ELIGIBILITY.CHARGE_ANYTIME_JOURNEY_NAME,
        screen: EV.SCREENS.MAKE_A_SWITCH,
      },
    });
  };

  const handleTabSwitch = useCallback(
    (tab: ModalTab) => {
      setMonthlyModalTab(tab);
      setMonthlyModalStep(1);
    },
    [setMonthlyModalTab, setMonthlyModalStep],
  );

  const handleNextStep = () => {
    const maxSteps =
      monthlyModalTab === 'what-you-get'
        ? MODAL_STEPS.WHAT_YOU_GET
        : MODAL_STEPS.NEED_TO_KNOW;

    if (monthlyModalStep < maxSteps) {
      setMonthlyModalStep(monthlyModalStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (monthlyModalStep > 1) {
      setMonthlyModalStep(monthlyModalStep - 1);
    }
  };

  return {
    showPaydModal,
    showMonthlyModal,
    monthlyModalTab,
    monthlyModalStep,

    openPaydModal,
    closePaydModal,
    openMonthlyModal,
    closeMonthlyModal,
    handleTabSwitch,
    handleNextStep,
    handlePrevStep,
  };
};
